// src/ReduxToolkit/Reducers/PageSlice.js
import { createSlice } from '@reduxjs/toolkit';

interface initialStateInterface {
  pages: Array<any>,
  generating: boolean
}

const initialState: initialStateInterface = {
  pages: [],
  generating: false,
};

const PageSlice = createSlice({
  name: 'Pages',
  initialState,
  reducers: {
    setPages(state, action) {
      state.pages = action.payload || state.pages;
    },
    setGenerating: (state, action) => {
      state.generating = action.payload
  }
  },
});

export const { setPages, setGenerating } = PageSlice.actions;
export default PageSlice.reducer;